import {
  isLegacyLiveChatEnabled,
  LIVE_CHAT_HOME_PATH,
  LIVE_CHAT_V2_PATH,
  LEGACY_LIVE_CHAT_PATH,
} from "../config/featureFlags";

/**
 * Base path for live-chat deep links (roomId, tabs).
 * Respects REACT_APP_LEGACY_LIVE_CHAT_ENABLED; prefers ChatV2 when legacy is off.
 */
export function getLiveChatBasePath(pathname = "") {
  const path = String(pathname || "");

  if (path === "/Live" || path.startsWith("/Live/")) {
    return isLegacyLiveChatEnabled ? LEGACY_LIVE_CHAT_PATH : LIVE_CHAT_V2_PATH;
  }

  if (
    path === "/chat" ||
    path.startsWith("/chat/") ||
    path.includes("/chatv2") ||
    path === "/live" ||
    path.startsWith("/live/")
  ) {
    return LIVE_CHAT_V2_PATH;
  }

  return LIVE_CHAT_HOME_PATH;
}
